import styled from "styled-components";

export const FormPass = styled.div`
    min-width: 400px;
    @media (max-width: 768px) {
        width: 100%;
        min-width: auto;
    }
`;

export const Footer = styled.div`
    // width: 100%;
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 20px 60px 0 0;
    gap: 20px;

    @media (max-width: 768px) {
        margin: 10px 10px 0 0;
        flex-wrap: wrap;
        gap: 10px;
    }
`;

export const TextButton = styled.button`
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
        text-decoration-color: #555;
    }
`;

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  min-height: 80vh;
`;